import React, { FC } from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const DefaultCompanyLogoIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.light;

  return (
    <SvgIcon {...props} width="24" height="25" viewBox="0 0 24 25">
      <g fill="none" fillRule="evenodd" transform="translate(0 .5)">
        <circle id="zaaqkvsdna" cx="12" cy="12" r="12" fill={fillColor} />
        <rect
          width="10.213"
          height="12.722"
          x="6.893"
          y="5.639"
          stroke="#FFF"
          mask="url(#0nefvwixcb)"
          rx="1"
        />
        <path
          fill="#FFF"
          d="M10.713 15.442H13.286999999999999V18.013H10.713zM7.16 7.692H16.841V8.692H7.16zM7.16 10.28H16.841V11.28H7.16z"
          mask="url(#0nefvwixcb)"
        />
      </g>
    </SvgIcon>
  );
};

export default DefaultCompanyLogoIcon;
